import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { useTranslation, Link } from "gatsby-plugin-react-i18next";

import * as styles from "../../assets/sass/modules/_sub-menu.module.scss";

const MenuTechnologies = () => {
  const data = useStaticQuery(graphql`
    query ($language: String) {
      locales: allLocale(filter: { language: { eq: $language } }) {
        edges {
          node {
            ns
            data
            language
          }
        }
      }
      technologies: allMarkdownRemark(
        filter: {
          frontmatter: { tag: { eq: "technology" }, slug: { ne: null } }
        }
        sort: { frontmatter: { order: ASC } }
      ) {
        nodes {
          frontmatter {
            title
            imageSrc
            imageAlt
            slug
          }
          id
        }
      }
    }
  `);

  const { t } = useTranslation();

  const technologies = data.technologies.nodes;

  return (
    <div className="container">
      <div className={styles.menuPanel}>
        <div className="row">
          <div className={`${styles.menuGroup} col-12 col-lg-6`}>
            <div className={styles.category}>{t("TECHNOLOGIES")}</div>
            <p className="featureDescription">
              {t("TECHNOLOGIES_MENU_DESCRIPTION")}
            </p>
          </div>
          <div className={`${styles.menuGroup} col-12 col-lg-6`}>
            <ul className={`${styles.linkList} row`}>
              {technologies.map((item, index) => (
                <li className="col-12 col-lg-6" key={index}>
                  <Link to={item.frontmatter.slug}>
                    <div className="d-flex align-items-center m-bottom-1">
                      <div className={styles.techLogo}>
                        <img
                          src={item.frontmatter.imageSrc}
                          alt={item.frontmatter.imageAlt}
                        />
                      </div>
                      <div>{item.frontmatter.title}</div>
                    </div>
                  </Link>
                </li>
              ))}
              <li className="col-12 col-lg-6 d-flex align-items-center" key="50">
                <Link to="/technologies" className="arrowLink arrowLink-sm">
                  {t("SEE_ALL_TECHNOLOGIES")}{" "}
                  <i className="icon dei-arrow-right"></i>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuTechnologies;
